import { InjectionToken } from '@angular/core';

const HTTP_REST_SERVICE = new InjectionToken('HttpRestService');

/**
 * Generated bundle index. Do not edit.
 */

export { HTTP_REST_SERVICE };
